import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { adminListUsers } from "../lib/api";

function fmtDate(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    if (isNaN(d)) return "—";
    return d.toLocaleDateString("en-US", { year: "numeric", month: "short", day: "numeric" });
  } catch {
    return "—";
  }
}

export default function AdminUsers() {
  const [users, setUsers] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [q, setQ] = useState("");

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const data = await adminListUsers();
      setUsers(data.users || []);
      setTotal(data.total || 0);
    } catch {
      toast.error("could not load users");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const filtered = q
    ? users.filter(
        (u) =>
          (u.email || "").toLowerCase().includes(q.toLowerCase()) ||
          (u.name || "").toLowerCase().includes(q.toLowerCase()),
      )
    : users;

  return (
    <div data-testid="admin-users">
      <div className="flex flex-wrap items-baseline gap-3 mb-3">
        <div className="text-[13px] font-bold" data-testid="users-total">
          {">"}_ {total} Google sign-up{total === 1 ? "" : "s"}
        </div>
        <input
          type="text"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="filter by email or name..."
          className="tv-input text-[12px] flex-1 min-w-[180px]"
          data-testid="users-filter"
        />
        <button className="tv-btn" onClick={load} data-testid="users-refresh">
          [refresh]
        </button>
      </div>

      {loading ? (
        <div className="text-[13px] text-[#888]">
          loading users...<span className="tv-blink">_</span>
        </div>
      ) : filtered.length === 0 ? (
        <div className="text-[13px] text-[#666]" data-testid="users-empty">
          {q ? "no users match that filter." : "no sign-ups yet."}
        </div>
      ) : (
        <table className="tv-table" data-testid="users-table">
          <thead>
            <tr>
              <th className="text-left">email</th>
              <th className="text-left">name</th>
              <th className="text-right">stacks</th>
              <th className="text-left">joined</th>
              <th className="text-left">last login</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((u) => (
              <tr key={u.email} data-testid={`user-row-${u.email}`}>
                <td>
                  {u.email}
                  {u.is_admin && (
                    <span
                      className="ml-2 text-[10px] border border-black px-1 py-0.5 uppercase tracking-wide"
                      data-testid={`user-admin-${u.email}`}
                    >
                      admin
                    </span>
                  )}
                </td>
                <td className="text-[#444]">{u.name || "—"}</td>
                <td className="text-right tabular-nums">{u.stacks}</td>
                <td className="text-[#444]">{fmtDate(u.created_at)}</td>
                <td className="text-[#444]">{fmtDate(u.last_login)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
